import api, { handleApiResponse } from './api';
import { RoleWithPermissions, Permission, ApiResponse } from '../types';

export const roleService = {
  async getAll(): Promise<RoleWithPermissions[]> {
    // El backend devuelve Page<RoleResponse> — extraemos el array .content.
    const response = await api.get<ApiResponse<{ content: RoleWithPermissions[] }>>
      ('/auth/roles?size=200&sort=id,asc');
    const data = handleApiResponse(response);
    return Array.isArray(data) ? data : (data?.content ?? []);
  },

  async create(data: { name: string; description: string; permissionIds: number[] }): Promise<RoleWithPermissions> {
    const response = await api.post<ApiResponse<RoleWithPermissions>>('/auth/roles', data);
    return handleApiResponse(response);
  },

  async update(id: number, data: { description?: string; permissionIds?: number[] }): Promise<RoleWithPermissions> {
    const response = await api.put<ApiResponse<RoleWithPermissions>>(`/auth/roles/${id}`, data);
    return handleApiResponse(response);
  },

  async deactivate(id: number): Promise<void> {
    await api.delete(`/auth/roles/${id}`);
  },

  async getPermissions(): Promise<Permission[]> {
    const response = await api.get<ApiResponse<Permission[]>>('/auth/roles/permissions');
    return handleApiResponse(response);
  },
};
